import { Icon, withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { GenericDrawer } from 'src/common/components/generic-drawer/generic-drawer';
import { EstimatesList } from 'views/compare-estimates/estimates.list';
import { ICompareEstimates } from 'src/common/interfaces/compare-estimates.interfaces';

interface ICompareEstimatesDrawer {
  estimates: ICompareEstimates[];
  filteredEstimates: ICompareEstimates[];
}

const UnprotectedCompareEstimatesDrawer = ({ estimates, filteredEstimates }: ICompareEstimatesDrawer) => {
  const drawerProps = {
    width: '400px',
    defaultTabIndex: 1,
    tabs: [
      {
        icon: <Icon icon="list" />,
        content: <EstimatesList estimates={estimates} filteredEstimates={filteredEstimates} />,
      },
    ],
  };

  return <GenericDrawer {...drawerProps} />;
};

export const CompareEstimatesDrawer = withErrorBoundary(UnprotectedCompareEstimatesDrawer, { isRightSideBar: true });
